import styled from 'styled-components'

const Benefits = styled.div`
  display: flex;
  height: 32px;
  padding: 0px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 20px;
  background: linear-gradient(107deg, rgba(255, 133, 36, 0.12) 22.6%, rgba(255, 94, 151, 0.12) 66.88%);
  color: var(--Brand, #ff763c);
  font-family: Rubik;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
`

export default Benefits
